import DialogActions from './DialogAction';
import DialogBody from './DialogBody';
import DialogContent from './DialogContent';
import DialogHeader from './DialogHeader';
import DialogRoot from './DialogRoot';

/**
 * 모달 V2. `open` prop으로 표시 여부를 제어.
 *
 * ```tsx
 * const { value: open, setValue: setOpen } = useBoolean(false);
 *
 * <Button onClick={() => setOpen(true)}>모달 열기</Button>
 * <LookoModalV2 open={open} onClose={() => setOpen(false)}>
 *   내용
 * </LookoModalV2>
 * ```
 */
export const LookoModalV2 = Object.assign(DialogRoot, {
  Header: DialogHeader,
  Content: DialogContent,
  Actions: DialogActions,

  /**
   * 모달의 감싸는 영역.
   *
   * 모달의 Content 와 Actions 를 감쌀 필요가 있을 때 사용하면 됩니다.
   * 예를 들어, form 으로 감쌀 필요가 있을 때.
   */
  Body: DialogBody,
});
